import React from 'react';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/illustration-communication.svg';

export const TheConsequencesStep = withTranslation('cbt')(({ t }: WithTranslation) => (
    <S.ContentRow>
        <S.ContentColumn md={14}>
            <S.StepHeading>{t('week-3.the-consequences-of-a-response.title')}</S.StepHeading>
            <S.StepDescription small>
                {t('week-3.the-consequences-of-a-response.description.1')}
            </S.StepDescription>
            <S.StepDescription small>
                <Trans i18nKey="week-3.the-consequences-of-a-response.description.2">
                    There can be <S.StyledWord underline>short-term</S.StyledWord> consequences as
                    well as
                    <S.StyledWord underline> long-term</S.StyledWord> consequences.
                </Trans>
            </S.StepDescription>
            <S.StepDescription small>
                <Trans i18nKey="week-3.the-consequences-of-a-response.description.3">
                    Often when our response to emotional distress is to avoid, the short-term
                    consequence is to feel a reduction in unpleasant emotions. We then learn that we
                    feel better when we avoid, so we will keep avoiding in the future.
                    Unfortunately, the <S.StyledWord underline> long-term </S.StyledWord>
                    consequence is usually worse distress and a less fulfilling life.
                </Trans>
            </S.StepDescription>
        </S.ContentColumn>
        <S.ContentColumn md={10}>
            <S.StepIcon large iconUrl={stepIcon} />
        </S.ContentColumn>
    </S.ContentRow>
));
